
import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

const Breadcrumb: React.FC = () => {
  const location = useLocation();
  
  const getBreadcrumbItems = (): BreadcrumbItem[] => {
    const path = location.pathname;
    
    const breadcrumbMap: { [key: string]: BreadcrumbItem[] } = {
      '/': [{ label: 'ホーム' }],
      '/search': [
        { label: 'ホーム', path: '/' },
        { label: '物件検索' }
      ],
      '/services': [
        { label: 'ホーム', path: '/' },
        { label: 'サービス' }
      ],
      '/about': [
        { label: 'ホーム', path: '/' },
        { label: '会社案内' }
      ],
      '/contact': [
        { label: 'ホーム', path: '/' },
        { label: 'お問い合わせ' }
      ]
    };
    
    return breadcrumbMap[path] || [{ label: 'ホーム', path: '/' }];
  };

  const breadcrumbItems = getBreadcrumbItems();

  // ホームページでは表示しない
  if (location.pathname === '/') {
    return null;
  }

  return (
    <nav className="bg-gray-50 py-4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ol className="flex items-center space-x-2 text-sm">
          {breadcrumbItems.map((item, index) => (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-gray-400 mx-2"></i>
              )}
              {item.path ? (
                <Link 
                  to={item.path} 
                  className="text-blue-600 hover:text-blue-800 transition-colors cursor-pointer"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-gray-700 font-medium">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
};

export default Breadcrumb;
